import type { VisualizationType } from '@tempo-io/roadmap-dto';

export type VisualizationUrlSegment = 'swimlane' | 'timeline' | 'table' | 'node-graph';

export function visualizationTypeToUrlSegment(type: VisualizationType): VisualizationUrlSegment {
  if (type === 'nodeGraph') return 'node-graph';
  return type;
}
